import React, { PureComponent } from 'react'
import {
  node, shape, object, func,
} from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import FormField from '@active/react-ui/FormField'
import { Locale, withI18n } from '@active/react-utils/i18n'

import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'
import CardNumberInfo from '../CardNumberInfo'
import imgMap from '../imgs/imgMap'

class ECheckDetail extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    fields: shape({
      address: object.isRequired,
    }).isRequired,
    children: node.isRequired,
    i18n: func.isRequired,
  }

  render() {
    const {
      children, paymentMethod, fields, i18n,
    } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)

    const subFields = {
      ...fields,
      accountType: info.getSummaryData(i18n),
    }

    return (
      <div className="checkout-payments checkout__payment-detail checkout__echeck-detail">
        <Form
          horizontal
          initialValues={subFields}
          className="form--vertical checkout__payment-detail--form checkout__echeck-detail--form"
        >
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.name" /></FormLabel>
            <FormStaticField
              name="accountName"
            />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.account" /></FormLabel>
            <FormField
              name="last2Digits"
              as={CardNumberInfo}
              paymentMethod={paymentMethod}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.type" /></FormLabel>
            <FormStaticField
              name="accountType"
            />
          </FormGroup>
          {children}
        </Form>
      </div>
    )
  }
}

export default withI18n(ECheckDetail)

const defaultIcon = [imgMap.ECheck, 'echeck']
export {
  defaultIcon,
}
